<cap-content-header>
  <cap-title>
    {{ "grundstueck.SucheTitel" | translate }}
  </cap-title>
</cap-content-header>

<ul [(activeId)]="searchMode" #nav="ngbNav" class="nav-tabs" ngbNav>
  <li [ngbNavItem]="'searchStandard'">
    <a ngbNavLink>{{ "Standardsuche" | translate }}</a>
    <ng-template id="standard" ngbNavContent>
      <cap-grundstueck-suche-standard (tabErweitertActive)="saveTabSettings($event)"></cap-grundstueck-suche-standard>
    </ng-template>
  </li>

  <li [disabled]="tabErweitertActive" [ngbNavItem]="'searchErweitert'">
    <a ngbNavLink>{{ "ErweiterteSuche" | translate }}</a>
    <ng-template id="erweitert" ngbNavContent>
      <cap-grundstueck-suche-erweitert (tabErweitertActive)="saveTabSettings($event)"></cap-grundstueck-suche-erweitert>
    </ng-template>
  </li>

  <li [ngbNavItem]="'searchFachId'">
    <a ngbNavLink>{{ "EgridSuche" | translate }}</a>
    <ng-template id="egrid" ngbNavContent>
      <cap-grundstueck-suche-egrid (tabErweitertActive)="saveTabSettings($event)"></cap-grundstueck-suche-egrid>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>
